<template>
  <div class="p-5 text-xs font-mono select-none min-w-max max-w-max mx-auto">
    <h1 class="text-2xl text-center">✨ Sensoreal Nexus</h1>
    <div class="mt-5 text-2xs opacity-50">
      Remote Hashes - api:
      <a
        class="underline"
        :href="
          `https://git.martins.com.au/martinsdigital/sensoreal-api/commit/${remoteHashes.api}`
        "
        target="_blank"
        >{{ remoteHashes.api || "⏳" }}</a
      >
      | dashboard:
      <a
        class="underline"
        :href="
          `https://git.martins.com.au/martinsdigital/sensoreal-dashboard/commit/${remoteHashes.dashboard}`
        "
        target="_blank"
        >{{ remoteHashes.dashboard || "⏳" }}</a
      >
      | touch:
      <a
        class="underline"
        :href="
          `https://git.martins.com.au/martinsdigital/sensoreal-touch/commit/${remoteHashes.touch}`
        "
        target="_blank"
        >{{ remoteHashes.touch || "⏳" }}</a
      >
      | favourites:
      <a
        class="underline"
        :href="
          `https://git.martins.com.au/martinsdigital/sensoreal-favourites/commit/${remoteHashes.favourites}`
        "
        target="_blank"
        >{{ remoteHashes.favourites || "⏳" }}</a
      >
      | webx:
      <a
        class="underline"
        :href="`https://git.martins.com.au/sensoreal/sensoreal-webx/commit/${remoteHashes.webx}`"
        target="_blank"
        >{{ remoteHashes.webx || "⏳" }}</a
      >
    </div>
    <fieldset class="mt-5">
      <legend class="font-bold text-lg mb-1">all projects</legend>
      <div
        v-for="app in keys(allProjects.apps)"
        :key="app"
        class="flex items-center justify-between flex-wrap bg-gray-200 odd:bg-gray-100 px-3"
      >
        <div class="w-48">
          <div class="font-bold">
            <span class="mr-2 text-2xs" style="font-family: emoji"></span
            >sensoreal-{{ app }}
          </div>
          <div class="text-2xs opacity-50">
            <a
              class="ml-5 underline"
              :href="
                `https://git.martins.com.au/${app === 'webx' ? 'sensoreal' : 'martinsdigital'}/sensoreal-${app}/commit/${remoteHashes[app]}`
              "
              target="_blank"
              >{{ remoteHashes[app] }}</a
            >
          </div>
        </div>
        <div class="flex-grow font-sans flex">
          <div class="w-28">
            <label
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': allProjects.apps[app].git_pull,
              }"
              ><div class="mb-1">
                git pull ↙️
              </div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].git_pull"
            /></label>
          </div>
          <div class="w-30">
            <label
              class=" w-30 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  allProjects.apps[app].remove_modules,
              }"
              ><div class="mb-1">rm node_modules 📦</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].remove_modules"
            /></label>
          </div>
          <div class="w-28">
            <label
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  allProjects.apps[app].npm_install,
              }"
              ><div class="mb-1">npm install 📦</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].npm_install"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app !== 'api'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  allProjects.apps[app].run_build,
              }"
              ><div class="mb-1">run build 🔨</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].run_build"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'touch'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  allProjects.apps[app].run_release,
              }"
              ><div class="mb-1">run production build 🔨</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].run_release"
            /></label>
          </div>
          <div class="w-28">
            <label v-if="app !== 'webx'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  allProjects.apps[app].restart_app,
              }"
              ><div class="mb-1">restart app 🚨</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].restart_app"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'api'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  allProjects.apps[app].backup_db,
              }"
              ><div class="mb-1">backup db 🙏🏻</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].backup_db"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'api'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': allProjects.apps[app].sync_crm,
              }"
              ><div class="mb-1">sync crm 🔄</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].sync_crm"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'touch'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  allProjects.apps[app].crm_release,
              }"
              ><div class="mb-1">push staging to production ✈️</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="allProjects.apps[app].crm_release"
            /></label>
          </div>
        </div>
        <transition name="alert">
          <pre
            v-show="app.output"
            :key="app.output"
            class="w-full select-text flex-shrink-0 text-2xs output"
            v-html="app.output"
          ></pre>
        </transition>
      </div>
    </fieldset>
    <button
      class="border-solid border-red-400 border-4 my-5 ml-auto block text-xl font-red text-red-400 px-2 py-1"
      :class="{
        'opacity-50 pointer-events-none': !isBatchTriggerActive,
      }"
      @click="updateAll()"
    >
      Trigger Batch Update
    </button>
    <fieldset v-for="server in servers" class="mt-5" :key="server.name">
      <legend class="font-bold text-lg mb-1">{{ server.name }}</legend>
      <div
        v-for="app in keys(server.apps)"
        :key="app"
        class="flex items-center justify-between flex-wrap bg-gray-200 odd:bg-gray-100 px-3"
      >
        <div class="w-48">
          <div class="font-bold">
            <span class="mr-2 text-2xs" style="font-family: emoji">{{
              remoteHashes[app]
                ? server.apps[app].hash === remoteHashes[app]
                  ? "✅"
                  : "⚠️"
                : "⏳"
            }}</span
            >sensoreal-{{ app }}
          </div>
          <div class="text-2xs opacity-50">
            <a
              class="ml-5 underline"
              :href="
                `https://git.martins.com.au/${app === 'webx' ? 'sensoreal' : 'martinsdigital'}/sensoreal-${app}/commit/${server.apps[app].hash}`
              "
              target="_blank"
              >{{ server.apps[app].hash }}</a
            >
          </div>
        </div>
        <div class="flex-grow font-sans flex">
          <div class="w-28">
            <label
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].git_pull,
              }"
              ><div class="mb-1">git pull ↙️</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].git_pull"
            /></label>
          </div>
          <div class="w-28">
            <label
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300':
                  server.apps[app].remove_modules,
              }"
              ><div class="mb-1">rm node_modules 📦</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].remove_modules"
            /></label>
          </div>
          <div class="w-28">
            <label
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].npm_install,
              }"
              ><div class="mb-1">npm install 📦</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].npm_install"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app !== 'api'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].run_build,
              }"
              ><div class="mb-1">run build 🔨</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].run_build"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'touch'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].run_release,
              }"
              ><div class="mb-1">run production build 🔨</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].run_release"
            /></label>
          </div>
          <div class="w-28">
            <label v-if="app !== 'webx'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].restart_app,
              }"
              ><div class="mb-1">restart app 🚨</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].restart_app"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'api'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].backup_db,
              }"
              ><div class="mb-1">backup db 🙏🏻</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].backup_db"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'api'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].sync_crm,
              }"
              ><div class="mb-1">sync crm 🔄</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].sync_crm"
            /></label>
          </div>
          <div class="w-28">
            <label
              v-if="app === 'touch'"
              class=" w-28 cursor-pointer py-2 px-2 inline-block hover:bg-blue-200 text-center"
              :class="{
                'bg-blue-300 hover:bg-blue-300': server.apps[app].crm_release,
              }"
              ><div class="mb-1">push staging to production ✈️</div>
              <input
                class="block mx-auto cursor-pointer"
                type="checkbox"
                v-model="server.apps[app].crm_release"
            /></label>
          </div>
        </div>
        <div class="flex items-center justify-center">
          <span
            v-if="server.apps[app].isLoading"
            class="animate-spin w-4 h-4 flex items-center justify-center"
            >⏳</span
          >
          <button
            class="border-solid border-2 border-black ml-4 px-2 py-1 opacity-10 hover:opacity-100"
            :class="{
              'opacity-50':
                server.apps[app].git_pull ||
                server.apps[app].remove_modules ||
                server.apps[app].npm_install ||
                server.apps[app].run_build ||
                server.apps[app].backup_db ||
                server.apps[app].sync_crm ||
                server.apps[app].restart_app ||
                server.apps[app].run_release,
            }"
            @click="
              submitUpdate(
                server,
                app,
                server.apps[app].git_pull,
                server.apps[app].remove_modules,
                server.apps[app].npm_install,
                server.apps[app].run_build,
                server.apps[app].backup_db,
                server.apps[app].sync_crm,
                server.apps[app].restart_app,
                server.apps[app].run_release,
                server.apps[app].crm_release
              )
            "
          >
            Trigger Update
          </button>
        </div>
        <transition name="alert">
          <pre
            v-show="server.apps[app].output"
            :key="server.apps[app].output"
            class="w-full select-text flex-shrink-0 text-2xs output"
            v-html="server.apps[app].output"
          ></pre>
        </transition>
      </div>
    </fieldset>
  </div>
</template>
<script>
import axios from "axios";
import config from "@/config";
export default {
  data() {
    return {
      allProjects: {
        apps: {
          api: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            backup_db: false,
            sync_crm: false,
            restart_app: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
          dashboard: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            run_build: false,
            run_release: false,
            restart_app: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
          touch: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            run_build: false,
            restart_app: false,
            run_release: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
          webx: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            run_build: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
          favourites: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            run_build: false,
            restart_app: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
        },
      },
      actions: [
        "git_pull",
        "remove_modules",
        "npm_install",
        "run_build",
        "run_release",
        "restart_app",
        "backup_db",
        "sync_crm",
        "crm_release",
      ],
      remoteHashes: {},
      servers: [],
    };
  },

  computed: {
    isBatchTriggerActive() {
      let isActive = false;

      const apps = Object.keys(this.allProjects.apps);
      apps.forEach(app => {
        this.actions.forEach(action => {
          if (action in this.allProjects.apps[app]) {
            if (this.allProjects.apps[app][action]) {
              isActive = true;
            }
          }
        });
      });

      return isActive;
    },
  },

  watch: {
    allProjects: {
      handler() {
        this.servers.forEach(server => {
          const apps = Object.keys(server.apps);

          apps.forEach(app => {
            this.actions.forEach(action => {
              if (action in server.apps[app]) {
                server.apps[app][action] = this.allProjects.apps[app][action];
              }
            });
          });
        });
      },
      deep: true,
    },
  },

  mounted() {
    config.apiServers.sort((a, b) => {
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;
      return 0;
    });

    config.apiServers.forEach(server => {
      this.servers.push({
        name: server.name,
        host: server.host,
        apps: {
          api: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            backup_db: false,
            sync_crm: false,
            restart_app: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
          dashboard: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            run_build: false,

            restart_app: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
          touch: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            run_build: false,
            restart_app: false,
            run_release: false,
            crm_release: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
          ...(server.webx ? {
            webx: {
              git_pull: false,
              remove_modules: false,
              npm_install: false,
              run_build: false,
              output: "",
              isLoading: false,
              hash: "loading hash...",
            },
          } : {}),
          favourites: {
            git_pull: false,
            remove_modules: false,
            npm_install: false,
            run_build: false,
            run_release: false,
            restart_app: false,
            output: "",
            isLoading: false,
            hash: "loading hash...",
          },
        },
      });
    });
    this.getRemoteHashes();
    this.getHashes();
  },

  methods: {
    keys(object) {
      return Object.keys(object);
    },

    getHashes() {
      this.servers.forEach(server => {
        axios
          .get(`${server.host}/nexus/hashes`)
          .then(res => {
            Object.keys(res.data).forEach(app => {
              if (server.apps[app]) server.apps[app].hash = res.data[app];
            });
          })
          .catch(() => {
            Object.keys(server.apps).forEach(app => {
              server.apps[app].hash = "hash failed";
            });
          });
      });
    },

    getRemoteHashes() {
      // Use a Webx project because not every server has that repository.
      const server = this.servers.find(server => server.apps.webx) || this.servers[0];
      axios
        .get(`${server.host}/nexus/remote-hashes`)
        .then(res => {
          this.remoteHashes = res.data;
        })
        .catch(e => {
          console.log(e);
        });
    },

    updateAll() {
      if (
        confirm(
          "This action will perform the selected actions on all servers. Are you sure?"
        )
      ) {
        if (confirm("No I'm serious. Are you sure!?")) {
          this.servers.forEach(server => {
            Object.keys(server.apps).forEach(app => {
              if (
                server.apps[app].git_pull ||
                server.apps[app].npm_install ||
                server.apps[app].run_build ||
                server.apps[app].backup_db ||
                server.apps[app].sync_crm ||
                server.apps[app].run_release ||
                server.apps[app].restart_app ||
                server.apps[app].crm_release
              ) {
                this.submitUpdate(
                  server,
                  app,
                  server.apps[app].git_pull,
                  server.apps[app].remove_modules,
                  server.apps[app].npm_install,
                  server.apps[app].run_build,
                  server.apps[app].backup_db,
                  server.apps[app].sync_crm,
                  server.apps[app].restart_app,
                  server.apps[app].run_release,
                  server.apps[app].crm_release
                );
              }
            });
          });
        }
      }
    },

    submitUpdate(
      server,
      app,
      git_pull,
      remove_modules,
      npm_install,
      run_build,
      backup_db,
      sync_crm,
      restart_app,
      run_release,
      crm_release
    ) {
      // if (confirm('Double check the server, app and operations about to be performed! Continue?')) {
      server.apps[app].output = "";
      server.apps[app].isLoading = true;
      axios
        .put(
          `${server.host}/nexus/update/${app}`,
          {
            git_pull,
            remove_modules,
            npm_install,
            run_build,
            backup_db,
            sync_crm,
            restart_app,
            run_release,
            crm_release,
          },
          {
            headers: {
              auth: process.env.VUE_APP_GIT_SECRET,
            },
          }
        )
        .then(res => {
          server.apps[app].output = res.data;
        })
        .catch(e => {
          server.apps[app].output = e;
        })
        .finally(() => {
          server.apps[app].isLoading = false;
          this.getHashes();

          this.actions.forEach(action => {
            if (action in server.apps[app]) {
              server.apps[app][action] = false;
            }

            if (action in this.allProjects.apps[app]) {
              this.allProjects.apps[app][action] = false;
            }
          });
        });
      // }
    },
  },
};
</script>
<style>
.output {
  background-color: transparent;
  transition: background-color 3s;
}

.alert-enter-to {
  background: rgba(44, 142, 255, 0.3);
  transition: background 0s;
}
</style>
